(function () {

  function getFocusableElements(container) {
    return Array.from(
      container.querySelectorAll(
        'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    );
  }

  function closePopup(popup, focusGuard) {
    popup.classList.remove('active');
    popup.style.visibility = 'hidden';
    document.querySelector('body').classList.remove('overflow-hidden');
    document.removeEventListener('focusin', focusGuard, true);
  }

  function initAgeVerification() {
    var popup = document.querySelector('.age-verification-popup');
    if (!popup) return;

    if (sessionStorage.getItem('age-verified')) return;

    popup.style.visibility = 'visible';
    popup.classList.add('active');
    document.querySelector('body').classList.add('overflow-hidden');

    var btnYes = popup.querySelector('[data-btn-yes]');

    if (btnYes) {
      btnYes.focus();
    }

    function focusGuard(event) {
      if (!popup.contains(event.target)) {
        event.stopImmediatePropagation();
        var focusable = getFocusableElements(popup);
        if (focusable.length) focusable[0].focus();
      }
    }
    document.addEventListener('focusin', focusGuard, true);

    popup.addEventListener('keydown', function (event) {
      if (event.key !== 'Tab') return;

      var focusable = getFocusableElements(popup);
      if (!focusable.length) return;

      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (event.shiftKey) {
        if (document.activeElement === first) {
          event.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    });

    if (btnYes) {
      btnYes.addEventListener('click', function () {
        sessionStorage.setItem('age-verified', 'true');
        closePopup(popup, focusGuard);
      });
    }

  }

  document.addEventListener('DOMContentLoaded', initAgeVerification);
  document.addEventListener('shopify:section:load', initAgeVerification);

})();
